/** External EHR practice rosters are large — require a bit of signal before search. */
export const EHR_PATIENT_SEARCH_MIN_QUERY_LENGTH = 2;

/** Page size for integrations patient-search proxy hits shown in the combobox. */
export const EHR_PATIENT_SEARCH_PAGE_SIZE = 5;
